export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14957.815a905b.jpg";